const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/insights/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/insights/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    params,
    search,
    context: {
      flags
    }
  }) => {
    if (!flags.insightsLandingPage) {
      throw redirect({
        to: '/org/$org/insights/deliverables',
        params: {
          org: params.org
        },
        search,
        replace: true
      });
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t('insights.summary.title')
  }),
  staticData: {
    topNav: {
      title: i18n.t('insights.summary.title')
    }
  }
});